import React, { useCallback, useEffect, useState } from "react";
import SearchComponent from "../../../components/dashboard-components/SearchComponent";
import StablecoinWidget from "../../../components/dashboard-components/StablecoinWidget";
import Widgets from "../../../components/dashboard-components/Widgets";
import { useAccountActivities } from "../../../sevices/hooks/account";
import AccountsTable from "../../../components/account_table";
import { useSearchParams } from "react-router-dom";
import { CURRENCIES } from "../transactionsSubmenu/Transactions";
import { ChevronDown, Download } from "lucide-react";
import jsPDF from "jspdf";
interface TransactionFilters {
  page: number;
  pageSize: number;
  currency?: string;
  date?: string;
  fromDate?: string;
  toDate?: string;
  search?: string;
}
const Accounts = () => {
  const [currentTab, setCurrentTab] = useState("fiat");
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState<TransactionFilters>({
    page: parseInt(searchParams.get("page") || "1"),
    pageSize: 10,
    currency: searchParams.get("currency") || undefined,
    date: searchParams.get("date") || "select",
    fromDate: searchParams.get("fromDate") || undefined,
    toDate: searchParams.get("toDate") || undefined,
    search: searchParams.get("search") || undefined,
  });
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [name, setName] = useState(searchParams.get("search") || "");

  const { data: userActivities, isLoading } = useAccountActivities({
    pageSize,
    page,
    name,
  });

  // Update URL params when filters change
  useEffect(() => {
    const newParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== "") {
        newParams.set(key, value.toString());
      }
    });
    setSearchParams(newParams, { replace: true });
  }, [filters, setSearchParams]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const dropdown = document.getElementById("currency-dropdown");
      if (dropdown && !dropdown.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

    const handlePageChange = useCallback((newPage: number) => {
      setFilters((prev) => ({
        ...prev,
        page: newPage,
      }));
    }, []);

    const handleCurrencyChange = useCallback((currency: string) => {
      setFilters((prev) => ({
        ...prev,
        currency: currency || undefined,
        page: 1,
      }));
      setIsDropdownOpen(false);
    }, []);

  const handleSearch = useCallback((query: string) => {
    setFilters((prev) => ({
      ...prev,
      search: query || undefined,
      page: 1,
    }));
  }, []);


    const handleExportPDF = useCallback(() => {
      if (!userActivities?.data?.data) return;

      const doc = new jsPDF();
      doc.setFontSize(18);
      doc.text("Transaction Report", 14, 22);

      doc.setFontSize(10);
      let filterText = `Date Filter: ${filters.date}`;
      if (filters.fromDate && filters.toDate) {
        filterText += ` (${filters.fromDate} to ${filters.toDate})`;
      }
      if (filters.currency) {
        filterText += ` | Currency: ${filters.currency}`;
      }
      doc.text(filterText, 14, 30);

      const tableData = userActivities.data.data.map(
        (
          item: {
            id: any;
            FullName: any;
            type: any;
            amount: { toLocaleString: () => any };
            currency: any;
            status: any;
          },
          index: number
        ) => [
          index + 1,
          item.id,
          item.FullName,
          item.type,
          item.amount.toLocaleString(),
          item.currency,
          item.status,
        ]
      );

      doc.autoTable({
        head: [
          [
            "REFERRAL ID",

            "Full Name",
            "EMAIL ADDRESS",
            "BANK",
            "ACCOUNT NO",
            // "Status",
          ],
        ],
        body: tableData,
        startY: 35,
        styles: { fontSize: 8 },
        headStyles: { fillColor: [0, 102, 204] },
      });

      doc.save(`transactions-${new Date().toISOString().split("T")[0]}.pdf`);
    }, [userActivities?.data?.data, filters]);
  console.log(userActivities?.data?.data?.data, "userActivities");
  return (
    <div className="h-screen w-full bg-#fff p-5 md:pr-5 md:pl-8 ">
      <div className="flex flex-row items-center justify-between  my-5 ">
        <h1 className="font-bold text-2xl text-[#071827] ">All Accounts</h1>
      </div>
      <div className="flex items-center justify-between gap-4 mb-6">
        <div className="flex items-center gap-4 flex-1">
          <SearchComponent
            placeholder="Search transactions..."
            onSearch={handleSearch}
          />

          <div className="relative" id="currency-dropdown">
            <button
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="flex items-center justify-between w-48 px-4 py-2 text-sm bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <span className="block truncate">
                {filters.currency
                  ? CURRENCIES.find((c) => c.value === filters.currency)?.label
                  : "All Currencies"}
              </span>
              <ChevronDown className="w-4 h-4 ml-2" />
            </button>

            {isDropdownOpen && (
              <div className="absolute z-10 w-48 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg">
                <div className="py-1">
                  <button
                    onClick={() => handleCurrencyChange("")}
                    className="block w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-100"
                  >
                    All Currencies
                  </button>
                  {CURRENCIES.map((currency) => (
                    <button
                      key={currency.value}
                      onClick={() => handleCurrencyChange(currency.value)}
                      className="block w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-100"
                    >
                      {currency.label}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        <button
          onClick={handleExportPDF}
          className="flex items-center gap-2 rounded-lg bg-[#676767] px-4 py-2 text-sm font-medium text-white hover:bg-[#0eb683]"
        >
          <Download className="h-4 w-4" />
          <span>Export PDF</span>
        </button>
      </div>
      {/* {currentTab === "fiat" ? ( */}
      <div>
        <AccountsTable
          data={userActivities?.data?.data}
          isLoading={isLoading}
          page={page}
          onPageChange={setPage}
          // currentTab={currentTab}
        />
      </div>
      {/* ) : (
        <div>
          <AccountsTable
            data={userActivities?.data?.data}
            isLoading={isLoading}
            page={page}
            onPageChange={setPage}
            // currentTab={currentTab}
          />
        </div>
      )} */}
    </div>
  );
};

export default Accounts;
